module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2r3r4n8r-67707d369d86685af75af9d87dbb988a.svg";